import { FunctionComponent, useEffect, useState } from "react";
import { useStopwatch } from "react-timer-hook";
import { useGlobalState } from "../../../MeetContext/MeetContext";
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { useChimeMeeting } from "../../../Chime/ChimeMeetingContext";
import { getScreenDimensions } from "../../../utils/helper";

type RecordingTimerProps = {
    initialRender: boolean;
    setInitialRender: (val: boolean) => void;
}

const RecordingTimer: FunctionComponent<RecordingTimerProps> = ({ initialRender, setInitialRender }) => {
    const { isAnyoneScreenSharing } = useGlobalState();
    const { isMobileScreen } = getScreenDimensions();
    const [showRecordingTime, setShowRecordingTime] = useState<boolean>(false);
    const { isRecording, recordingStartTime } = useChimeMeeting();

    let stopwatchOffset = new Date();
    let recordingStartedAt = recordingStartTime ? new Date(recordingStartTime).getTime() : Date.now();
    let timeDiffInSeconds = (Date.now() - recordingStartedAt) / 1000;  // convert milliseconds to seconds
    stopwatchOffset.setSeconds(stopwatchOffset.getSeconds() + timeDiffInSeconds);
    const {
        seconds,
        minutes, 
        hours
    } = useStopwatch({autoStart: true, offsetTimestamp: stopwatchOffset });

    useEffect(() => {
        if (initialRender) {
            setTimeout(() => {
                setShowRecordingTime(true);
            }, 3000);
            setInitialRender(false);
        }
        else {
            setShowRecordingTime(true);
        }
    }, [])


    return (
        <>
            {(isRecording) &&
                    <div className="session-record" style={{"left": isMobileScreen ? 'unset' : isAnyoneScreenSharing ? "0px" : "25px", "right" : !isMobileScreen ? 'unset' : isAnyoneScreenSharing ? "0px" : "25px",}}>
                        <div>
                            <RadioButtonCheckedIcon className="record-icon"/> 
                        </div>
                        {
                            showRecordingTime ?
                            <div>
                                <span>{hours ? `${String(hours).padStart(2, '0')}:` : ""}</span><span>{minutes ? `${String(minutes).padStart(2, '0')}:` : "00:"}</span><span>{String(seconds).padStart(2, '0')}</span>
                            </div> :
                            <span>Recording</span>
                        }
                    </div>
                }
        </>
    )
}

export default RecordingTimer;
